import React from 'react';

export default class Page5 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">

                                            <table className="ilead_v_sport tablesrink people_active" border="0"
                                                   cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th className="green_curve green_curve1" align="left"
                                                        valign="top" width="50%">A Need for Variety…
                                                    </th>
                                                </tr>
                                                <tr>

                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="50%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg">What you’ll see: </span> Interest
                                                            in new ideas, start-up rather than closure,
                                                            flexibility, moves easily from one
                                                            task to another.</p></div>

                                                    </td>
                                                </tr>
                                                <tr>

                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="50%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg">How to harness it: </span> Encourage
                                                            innovation, involvement at the start of projects,
                                                            provide opportunities
                                                            for a change of environment and responsibilities.
                                                        </p></div>

                                                    </td>
                                                </tr>
                                                <tr>

                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="50%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg">Watch out for: </span>Signs
                                                            of boredom, lack of follow-through and closure,
                                                            putting personal agenda
                                                            ahead of business agenda, being too flexible with
                                                            regulations.</p></div>


                                                    </td>
                                                </tr>

                                                </tbody>
                                            </table>

                                            <table className="ilead_v_sport tablesrink people_active" border="0"
                                                   cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th className="green_curve green_curve1" align="left"
                                                        valign="top" width="50%">A Need for Structure…
                                                    </th>
                                                </tr>
                                                <tr>

                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="50%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg">What you’ll see: </span> Organisation,
                                                            reliability, predictability, structured work, plenty
                                                            of planning in
                                                            meetings and a need for clarity.</p></div>

                                                    </td>
                                                </tr>
                                                <tr>

                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="50%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg">How to harness it: </span> Plenty
                                                            of clarity when planning, build in clear structures
                                                            for meetings, regularly
                                                            agree goals and targets, engage in projects that
                                                            need micro-managing.</p></div>

                                                    </td>
                                                </tr>
                                                <tr>

                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="50%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg">Watch out for: </span> Inflexibility,
                                                            uncertainty when dealing with ambiguity, being
                                                            overly rule-bound,
                                                            perfectionism.</p></div>


                                                    </td>
                                                </tr>

                                                </tbody>
                                            </table>
                                            <table className="ilead_v_sport tablesrink people_active" border="0"
                                                   cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th className="green_curve green_curve1" align="left"
                                                        valign="top" width="50%">A Need to Care…
                                                    </th>
                                                </tr>
                                                <tr>

                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="50%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg">What you’ll see: </span>Considerate
                                                            behaviours, concern for welfare, questions based on
                                                            feeling more
                                                            than fact, empathy, support.</p></div>

                                                    </td>
                                                </tr>
                                                <tr>

                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="50%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg">How to harness it: </span> Put
                                                            into a support role within the team, give ‘people
                                                            responsibilities’ to manage.</p></div>

                                                    </td>
                                                </tr>
                                                <tr>

                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="50%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg">Watch out for: </span>Avoiding
                                                            confrontation, over-sensitivity to others’ comments,
                                                            tolerating too many
                                                            requests for support, lacking a ‘task focus’. </p>
                                                        </div>


                                                    </td>
                                                </tr>

                                                </tbody>
                                            </table>

                                            <table className="ilead_v_sport tablesrink people_active" border="0"
                                                   cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th className="green_curve green_curve1" align="left"
                                                        valign="top" width="50%">A Need for Control…
                                                    </th>
                                                </tr>
                                                <tr>

                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="50%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg">What you’ll see: </span> Highly
                                                            organised, planful and detailed approach, strong
                                                            dislike of ambiguity.</p>

                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>

                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="50%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg">How to harness it: </span> Provide
                                                            opportunities to manage tasks and projects, provide
                                                            them with team
                                                            responsibilities, capitalise on personal
                                                            organisation.</p></div>

                                                    </td>
                                                </tr>
                                                <tr>

                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="50%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg">Watch out for: </span> Tension/frustration
                                                            with ambiguity, poor delegation (‘telling’ others,
                                                            rather than
                                                            influencing them). </p></div>


                                                    </td>
                                                </tr>

                                                </tbody>
                                            </table>

                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">IDENTIFYING MOTIVATORS – A QUESTIONNAIRE</span>
                                            </div>
                                            <p>This will help you reflect on your own and/or your colleagues’
                                                motivation. It’s about what you see in others’ behaviour at
                                                work. When designing this questionnaire we used research about
                                                people behaving in ways that reflect their personal values (what
                                                matters to them). Bear this in mind when you look at the
                                                results, because like most theory, it’s useful but not bomb
                                                proof!</p>
                                            <p>It won’t take more than about five minutes and you’ll have a
                                                ‘map’ of your own and others’ ‘primary motivators’ – you could
                                                make copies for however many people you have in mind.</p>

                                            <div className="left-btn"><div
                                                onClick={this.props.handleChangePage('Page4')}
                                                className="button-next-previous-done">&lt;&lt; Previous </div></div>
                                            <div className="right-btn"><div
                                                onClick={this.props.handleChangePage('Page6')}
                                                className="button-next-previous-done">Next &gt;&gt;</div></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}